<template>
  <div class="wrapper">
    <div class="top">
      <div class="t1">支持琴岛通NFC卡机型</div>
      <div class="t2">机型列表供参考，实际支持机型以手机厂商为准</div>
    </div>
    <div class="item" v-for="item in list" :key="item.orderId">
      <div class="title">
        {{item.brand}}
      </div>
      <van-grid :border="false" :column-num="5">
        <van-grid-item v-for="value in item.nfcPhoneModels" :key="value.model" :text="value.name" />
      </van-grid>
    </div>
  </div>
</template>
<script>
import { querySupportNfcPhoneModel } from '@/api/qdt'
import { Grid, GridItem } from 'vant'
export default {
  name: 'nfcPhoneModel',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      const data = {
        appInfo: {
          appVersion: '1.0',
          bundleId: 'h5',
          machineModel: '',
          sourceSystem: 2,
          systemVersion: '1.0'
        }
      }
      querySupportNfcPhoneModel(data).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            this.list = res.data.result
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper{
  box-sizing: border-box;
  background: #F8F8F8;
  min-height: 100vh;
  padding: 10px 0;
}
.top{
  display: flex;
  flex-direction: column;
  padding: 12px 0 18px 15px;
  background: white;
  .t1{
    font-size: 16px;
    color: #282828;
  }
  .t2{
    font-size: 11px;
    color: #757575;
    margin-top: 12px;
  }
}
.item{
  margin-top: 10px;
  background: white;
  padding-left: 5px;
  .title{
    padding: 10px 0;
    margin-left: 10px;
    border-bottom: 1px solid #efefef;
    font-size: 16px;
    color: #282828;
  }
}

</style>
